'use client'
import {useEffect, useState} from "react";
import {useRouter, useSearchParams} from "next/navigation";
import CategoryFilter from "@/app/components/pages/shop/CategoryFilter";
import {useSelector} from "react-redux";
import {useFiltersHook} from "@/app/hooks/useFiltersHook";

const ProductFilter = ({data, routePath, onChange, showCategoryFilter = true}) => {
    const whoCategory = useSelector(state => state.filters.whoCategory)
    const eventCategory = useSelector(state => state.filters.eventCategory)
    const location = useSelector(state => state.filters.location)
    const price = useSelector(state => state.filters.price)
    const category = useSelector(state => state.filters.category)

    const [defaultValues, setDefaultValues] = useState({
        who_category: whoCategory,
        event_category: eventCategory,
        location: location,
        price: price,
        category: category
    })
    const {whoCategories, eventCategories, locationCategories, priceCategories, productCategories} = data
    const router = useRouter()
    const searchParams = useSearchParams()

    const queryWho = searchParams.get('who_category')
    const queryEvent = searchParams.get('event_category')
    const queryLocation = searchParams.get('location')
    const queryPrice = searchParams.get('price')
    const queryCategory = searchParams.get('category')

    useFiltersHook({
        whoCategories, eventCategories, locationCategories, priceCategories, productCategories,
        queryWho,
        queryEvent,
        queryLocation,
        queryPrice,
        defaultValues,
        setDefaultValues,
        queryCategory
    })

    const [filters, setFilters] = useState({})

    const onFilterChange = (item) => {

        const filterData = {
            ...filters,
            ...item
        }

        setFilters(filterData)
        onChange(filterData)
    }

    return <div>
        {
            showCategoryFilter &&
            <CategoryFilter
                productCategories={data.productCategories} defaultValue={defaultValues.category} onChange={onFilterChange}/>
        }

    </div>

}

export default ProductFilter
